import { priceToLicense } from "../../api/util/stripe/stripe-secrets";
import subscriptionLimits, { SubscriptionLimit } from "./limits";

/**
 * If the price is undefined, we lock the feature. If the feature requires an amount check, we check
 * the amount. If the feature doesn't require an amount check, we check if the feature is available
 * with the current plan
 * @param {string} price - The price of the current subscription
 * @param {SubscriptionLimit} feature - The feature you want to check
 * @param {number} [amountCurrent] - The amount of the feature that is currently used. For example, the
 * amount of users in a team.
 * @returns A boolean indicating if the user has access
 */
const checkSubscription = (price: string, feature: SubscriptionLimit, amount?: number, amountValuations?: number, isTrial?: boolean): boolean => {
    // If undefined, we assume something is not loaded or not right and therefore lock the feature
    if (!price) return false;
    const featureLimit = subscriptionLimits[feature][priceToLicense[price]];
    const simpleNumFeature =
        feature === "numTeamUsers" || feature === "numLocations" || "numCustomPipelines" || feature === "numRealEstateLandingPages" || "numAiTokens";

    // If we have a simpleNumFeature and the feature requires an amount check, then we do the check
    if (simpleNumFeature && typeof amount !== "undefined" && typeof featureLimit === "number" && featureLimit > 0) return amount <= featureLimit;
    // If we have amount = amountUsers and the feature requires an amount check, then we do the check
    else if (
        feature === "numValuationsPerMonth" &&
        typeof amount !== "undefined" &&
        typeof amountValuations !== "undefined" &&
        typeof featureLimit === "number"
    )
        return isTrial ? amountValuations < (amount === 1 ? 2 : Math.min(2 * (1 + amount), 6)) : amountValuations < featureLimit * amount;
    // if no amount check is needed, we check if the feature is available with the current plan
    else return !!featureLimit;
};

export default checkSubscription;

export const getRemainingValuations = (price?: string, amountUsers?: number, amountValuations?: number, isTrial?: boolean): number => {
    const featureLimit = subscriptionLimits["numValuationsPerMonth"][priceToLicense[price]];
    return isTrial ? (amountUsers === 1 ? 2 : Math.min(2 * (1 + amountUsers), 6)) - amountValuations : featureLimit * amountUsers - amountValuations;
};

// it uses for features with amount
export const getAccessedAmount = (price: string, feature: SubscriptionLimit) => {
    // If undefined, we assume something is not loaded or not right and therefore lock the feature
    if (!price) return 0;
    const featureLimit = subscriptionLimits[feature][priceToLicense[price]];
    if (feature === "numCustomPipelines" && typeof featureLimit === "number") return featureLimit;
};
